var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-star',{ref:"employee",attrs:{"config":{
    x: _vm.employee.currentCoord[0],
    y: _vm.employee.currentCoord[1],
    numPoints: 5,
    innerRadius: 6,
    outerRadius: 3,
    fill: _vm.EMPLOYEE_ACTIVITY_COLOR[_vm.activityName]
      || _vm.EMPLOYEE_ACTIVITY_COLOR.DEFAULT,
    listening: false,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }